import { getLocationString } from './helpers'

export const NAVIGATIONS_UPDATE = 'NAVIGATIONS_UPDATE'

export const updateNavigations = location => ({
  type: NAVIGATIONS_UPDATE, navigation: getLocationString(location)
})
